import _defineProperty from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Remediator } from './Base/Remediator.js';
var SelectEnrollmentChannel = /*#__PURE__*/function (_Remediator) {
  function SelectEnrollmentChannel() {
    _classCallCheck(this, SelectEnrollmentChannel);
    return _callSuper(this, SelectEnrollmentChannel, arguments);
  }
  _inherits(SelectEnrollmentChannel, _Remediator);
  return _createClass(SelectEnrollmentChannel, [{
    key: "canRemediate",
    value: function canRemediate() {
      if (this.values.channel) {
        return true;
      }
      if (this.values.authenticator) {
        var _this$values$authenti = this.values.authenticator,
          id = _this$values$authenti.id,
          channel = _this$values$authenti.channel;
        if (!!id && !!channel) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "getNextStep",
    value: function getNextStep(authClient, context) {
      var common = _superPropGet(SelectEnrollmentChannel, "getNextStep", this, 3)([authClient, context]);
      var authenticator = context.currentAuthenticator.value;
      return Object.assign(Object.assign({}, common), {
        authenticator: authenticator
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      var _a;
      var remediationValue = this.remediation.value[0].value;
      return {
        authenticator: {
          id: remediationValue.form.value[0].value,
          channel: ((_a = this.values.authenticator) === null || _a === void 0 ? void 0 : _a.channel) || this.values.channel
        },
        stateHandle: this.values.stateHandle
      };
    }
  }, {
    key: "getValuesAfterProceed",
    value: function getValuesAfterProceed() {
      var _this = this;
      this.values = _superPropGet(SelectEnrollmentChannel, "getValuesAfterProceed", this, 3)([]);
      delete this.values.authenticators;
      var filterKey = this.values.channel ? 'channel' : 'authenticator';
      var trimmedValues = Object.keys(this.values).filter(function (valueKey) {
        return valueKey !== filterKey;
      });
      return trimmedValues.reduce(function (values, valueKey) {
        return Object.assign(Object.assign({}, values), _defineProperty({}, valueKey, _this.values[valueKey]));
      }, {});
    }
  }]);
}(Remediator);
SelectEnrollmentChannel.remediationName = 'select-enrollment-channel';
export { SelectEnrollmentChannel };